<template>
  <div
    class="sidebar"
    :data-color="activeColor"
    :data-image="backgroundImage"
    :style="sidebarStyle"
  >
    <div class="logo" style="text-align: center">
      <a class="simple-text logo-normal" @click="onClick()">{{ title }}</a>
    </div>

    <div class="sidebar-wrapper">
      <slot name="content"></slot>
      <md-list class="nav">
        <!--
        By default vue-router adds an active class to each route link.
        This way the links are colored when clicked
        -->
        <slot> <sidebar-link></sidebar-link> </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
import SidebarLink from './SidebarLink.vue';
const bg = require('../../assets/img/sidebar-3.jpg');
const logo = require('../../assets/img/buypower.png');
export default {
  components: {
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: 'Buypower Dashboard',
    },
    backgroundImage: {
      type: String,
      default: bg,
    },
    imgLogo: {
      type: String,
      default: logo,
    },
    activeColor: {
      type: String,
      default: 'orange',
      validator: (value) => {
        const acceptedValues = ['', 'purple', 'blue', 'green', 'orange', 'red'];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
  },
  data: () => ({
    slides: [
      {
        title: 'Wallet Balance',
        content: 'Slide content.',
      },
      {
        title: 'Commission Balance',
        content: 'Slide content',
      },
    ],
  }),
};
</script>
<style>
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}
.carousel {
  margin: 100px 0;
}
</style>
